
export const teams = {
  'Chicago CHI': {
    city: 'Chicago',
    nickname: 'Sky',
    primary: '#FFCD00',
    secondary: '#418FDE',
    tertiary: '#FFFFFF',
    short: 'CHI',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/sky-secondary-logo_cMEUnxp.svg',
  },
  'Indiana IND': {
    city: 'Indiana',
    nickname: 'Fever',
    primary: '#C8102E',
    secondary: '#041E42',
    tertiary: '#FFCD00',
    short: 'IND',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/fever-secondary-logo_MmxRfSu.svg',
  },
  'Las Vegas LV': {
    city: 'Las Vegas',
    nickname: 'Aces',
    primary: '#BA0C2F',
    secondary: '#000000',
    tertiary: '#85714D',
    short: 'LV',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/aces-secondary-logo_wKiAlb1.svg',
  },
  'Minnesota MIN': {
    city: 'Minnesota',
    nickname: 'Lynx',
    primary: '#0C2340',
    secondary: '#236192',
    tertiary: '#78BE20',
    short: 'MIN',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/lynx-secondary-logo_TIldoNl.svg',
  },
  'New York NY': {
    city: 'New York',
    nickname: 'Liberty',
    primary: '#6ECEB2',
    secondary: '#000000',
    tertiary: '#FF671F',
    short: 'NY',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/liberty-secondary-logo_tbMluK2.svg',
  },
  'Phoenix PHX': {
    city: 'Phoenix',
    nickname: 'Mercury',
    primary: '#201747',
    secondary: '#CB6015',
    tertiary: '#B1B3B3',
    short: 'PHX',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/mercury-secondary-logo_ZMX3gb7.svg',
  },
  'Seattle SEA': {
    city: 'Seattle',
    nickname: 'Storm',
    primary: '#FBE122',
    secondary: '#2C5234',
    tertiary: '#A2AAAD',
    short: 'SEA',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/storm-secondary-logo_FKcXqld.svg',
  },
  'Atlanta ATL': {
    city: 'Atlanta',
    nickname: 'Dream',
    primary: '#C8102E',
    secondary: '#418FDE',
    tertiary: '#CED9E5',
    short: 'ATL',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/dream-secondary-logo_BUSuKyB.svg',
  },
  'Washington WSH': {
    city: 'Washington',
    nickname: 'Mystics',
    primary: '#0C2340',
    secondary: '#C8102E',
    tertiary: '#8A8D8F',
    short: 'WSH',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/mystics-secondary-logo_HQWwqZR.svg',
  },
  'Connecticut CONN': {
    city: 'Connecticut',
    nickname: 'Sun',
    primary: '#A6192E',
    secondary: '#041E42',
    tertiary: '#DC4405',
    short: 'CONN',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/sun-secondary-logo_v2JTOg4.svg',
  },
  'Los Angeles LA': {
    city: 'Los Angeles',
    nickname: 'Sparks',
    primary: '#FFC72C',
    secondary: '#702F8A',
    tertiary: '#00B398',
    short: 'LA',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/sparks-secondary-logo_KFymXlt.svg',
  },
  'Dallas DAL': {
    city: 'Dallas',
    nickname: 'Wings',
    primary: '#0C2340',
    secondary: '#C4D600',
    tertiary: '#00A9E0',
    short: 'DAL',
    logo: 'https://cdn.pivotanalysis.app/media/images/teams/wings-secondary-logo_oyqQx6W.svg',
  },
}

export default {
  teams,
}
